import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Download = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <circle cx="8" cy="8" r="6.5" stroke={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.938 8.62799C11.1258 8.83047 11.1139 9.14683 10.9114 9.33459L8.33997 11.7192C8.14819 11.897 7.85177 11.897 7.66 11.7192L5.08857 9.33459C4.88609 9.14683 4.87416 8.83047 5.06193 8.62799C5.2497 8.42551 5.56606 8.41359 5.76854 8.60135L7.49998 10.207L7.49998 4.39746C7.49998 4.12132 7.72384 3.89746 7.99998 3.89746C8.27612 3.89746 8.49998 4.12132 8.49998 4.39746L8.49998 10.207L10.2314 8.60135C10.4339 8.41359 10.7503 8.42551 10.938 8.62799Z"
        fill={color}
      />
    </svg>
  )
})

export default Download
